import Grid from '@mui/material/Grid';
//import TextCard from './TextCard';
import { useTheme } from "@mui/material";


export default function PanelLine({ marker, icon_1, }) {

  const theme = useTheme();
   
    return (

      theme.palette.mode === "light" ? (
     
      <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}> 
                   
          <Grid size={10}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  {marker} </Grid> 
          <Grid size={2}  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   {icon_1} </Grid> 
       
      </Grid>    
      
      ) : (

   
        <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}> 
                   
                   <Grid size={10}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  {marker} </Grid> 
                   <Grid size={2}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  {icon_1} </Grid>
     
    </Grid>    

      )

    );
  }